import React from "react";
import cx from "classnames";
import "./AllocationBar.scss";
export const AllocationBarIntl = ({ risk, messages, "data-test-id": dataTestId, }) => {
    const stocksClasses = cx("allocation-bar-stocks", {
        exclusive: risk === 100,
        hidden: risk === 0,
    });
    const bondsClasses = cx("allocation-bar-bonds", {
        exclusive: risk === 0,
        hidden: risk === 100,
    });
    return (React.createElement("div", { className: "allocation-bar", "data-test-id": dataTestId },
        React.createElement("div", { className: "stock-number", "data-test-id": `${dataTestId}-stocks` }, messages.stocks),
        React.createElement("div", { className: "bonds-number", "data-test-id": `${dataTestId}-bonds` }, messages.bonds),
        React.createElement("div", { className: stocksClasses, style: { width: `${risk}%` } },
            React.createElement("span", null)),
        React.createElement("div", { className: bondsClasses, style: { width: `${100 - risk}%` } },
            React.createElement("span", null))));
};
